import { date } from 'quasar'

class ActionPlanTask {
  constructor (_actionPlanTask) {
    if (typeof _actionPlanTask !== 'undefined') {
      this.id = _actionPlanTask.id ? _actionPlanTask.id : null
      this.title = _actionPlanTask.title ? _actionPlanTask.title : null
      this.file_by_id = _actionPlanTask.file_by_id ? _actionPlanTask.file_by_id : null
      this.folder_by_id = _actionPlanTask.folder_by_id ? _actionPlanTask.folder_by_id : null
      this.location_folder_id = _actionPlanTask.location_folder_id ? _actionPlanTask.location_folder_id : null
      this.root_folder_id = _actionPlanTask.root_folder_id ? _actionPlanTask.root_folder_id : null
      this.priority = _actionPlanTask.priority ? _actionPlanTask.priority : null
      this.picture = _actionPlanTask.picture ? [_actionPlanTask.picture] : []
      this.picture = _actionPlanTask.task_pictures ? _actionPlanTask.task_pictures.length > 0 ? _actionPlanTask.task_pictures : [] : []
      this.item_picture = _actionPlanTask.item_picture ? _actionPlanTask.item_picture : null
      this.item_comment = _actionPlanTask.item_comment ? _actionPlanTask.item_comment : null
      this.comment = _actionPlanTask.comment ? _actionPlanTask.comment : null
      this.picture_evidence = _actionPlanTask.picture_evidence ? _actionPlanTask.picture_evidence : null
      this.comment_evidence = _actionPlanTask.comment_evidence ? _actionPlanTask.comment_evidence : null
      this.file_evidence = _actionPlanTask.file_evidence ? _actionPlanTask.file_evidence : null
      this.start_date = _actionPlanTask.start_date ? _actionPlanTask.start_date : date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      this.start_date_utc = _actionPlanTask.start_date_utc ? _actionPlanTask.start_date_utc : null
      this.is_accessible = _actionPlanTask.is_accessible !== undefined ? _actionPlanTask.is_accessible : true
      this.end_date = _actionPlanTask.end_date ? _actionPlanTask.end_date : null
      this.end_date_utc = _actionPlanTask.end_date_utc ? _actionPlanTask.end_date_utc : null
      this.value = _actionPlanTask.value ? _actionPlanTask.value : 0
      this.verified = _actionPlanTask.verified ? _actionPlanTask.verified : 0
      this.role_id = _actionPlanTask.role_id ? _actionPlanTask.role_id : null
      this.created_at = _actionPlanTask.created_at ? _actionPlanTask.created_at : null
      this.updated_at = _actionPlanTask.updated_at ? _actionPlanTask.updated_at : null
      this.ocurrence_id = _actionPlanTask.ocurrence_id ? _actionPlanTask.ocurrence_id : null
      this.form_id = _actionPlanTask.form_id ? _actionPlanTask.form_id : null
      this.item_id = _actionPlanTask.item_id ? _actionPlanTask.item_id : null
      this.category = _actionPlanTask.tag ? _actionPlanTask.tag : null
      this.category2 = _actionPlanTask.tag2 ? _actionPlanTask.tag2 : null
      this.tag = _actionPlanTask.tag ? _actionPlanTask.tag : null
      this.area_id = _actionPlanTask.area_id ? _actionPlanTask.area_id : null
      this.hierarchy_site_id = _actionPlanTask.hierarchy_site_id ? _actionPlanTask.hierarchy_site_id : null
      this.hierarchy_subcategory_id = _actionPlanTask.hierarchy_subcategory_id ? _actionPlanTask.hierarchy_subcategory_id : null
      this.enforce_evidence = _actionPlanTask.enforce_evidence ? _actionPlanTask.enforce_evidence : null
      this.form_evidence = _actionPlanTask.form_evidence ? _actionPlanTask.form_evidence : null
      this.priority = _actionPlanTask.priority ? _actionPlanTask.priority : null
      this.timezone = _actionPlanTask.timezone ? _actionPlanTask.timezone : null
      // Nombres de la tarea
      this.created_by_id = _actionPlanTask.created_by_data ? _actionPlanTask.created_by_data.id : null
      this.created_by = _actionPlanTask.created_by ? _actionPlanTask.created_by : null
      this.created_by = _actionPlanTask.created_by_data ? _actionPlanTask.created_by_data.full_name : this.created_by
      this.assigned_to_id = _actionPlanTask.assigned_to_data ? _actionPlanTask.assigned_to_data.id : null
      this.assigned_to = _actionPlanTask.assigned_to ? _actionPlanTask.assigned_to : null
      this.assigned_to = _actionPlanTask.assigned_to_data ? _actionPlanTask.assigned_to_data.full_name : this.assigned_to
      // locacion
      this.location = _actionPlanTask.location ? _actionPlanTask.location.name : _actionPlanTask.location_data ? _actionPlanTask.location_data : null
      this.location_id = _actionPlanTask.location_id ? _actionPlanTask.location_id : null
      this.dateDiff = _actionPlanTask.dateDiff ? _actionPlanTask.dateDiff : null
      this.stateNow = _actionPlanTask.stateNow ? _actionPlanTask.stateNow : null
      this.stateValue = _actionPlanTask.stateValue ? _actionPlanTask.stateValue : null
      this.state = _actionPlanTask.state ? _actionPlanTask.state : null
      this.review_status = _actionPlanTask.review_status ? _actionPlanTask.review_status : null
      this.attachments = _actionPlanTask.attachments ? _actionPlanTask.attachments : []
      this.routine_event_id = _actionPlanTask.routine_event_id ? _actionPlanTask.routine_event_id : null
      this.sprint_plan_id = _actionPlanTask.sprint_plan_id ? _actionPlanTask.sprint_plan_id : null
      this.origin_task_label = _actionPlanTask.origin_task_label ? _actionPlanTask.origin_task_label : null
      this.short_name = _actionPlanTask.short_name ? _actionPlanTask.short_name : null
    } else {
      this.id = null
      this.title = null
      this.file_by_id = null
      this.folder_by_id = null
      this.location_folder_id = null
      this.root_folder_id = null
      this.action_plan_id = null
      this.priority = null
      this.role_id = null
      this.picture = null
      this.comment = null
      this.picture_evidence = null
      this.comment_evidence = null
      this.file_evidence = null
      this.start_date = date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      this.start_date_utc = null
      this.is_accessible = true
      this.end_date = null
      this.value = 0
      this.verified = 0
      this.item_id = null
      this.tag = null
      this.enforce_evidence = null
      this.review_status = null
      this.routine_event_id = null
      this.sprint_plan_id = null
      this.origin_task_label = null
      this.short_name = null
    }
  }

  get isExpired () {
    return new Date() > this.end_date
  }
}

export default ActionPlanTask
